var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM5.35147 11.3515C5.12643 11.5765 5 11.8817 5 12.2C5 12.5183 5.12643 12.8235 5.35147 13.0485C5.57652 13.2736 5.88174 13.4 6.2 13.4H18.2C18.5183 13.4 18.8235 13.2736 19.0485 13.0485C19.2736 12.8235 19.4 12.5183 19.4 12.2C19.4 11.8817 19.2736 11.5765 19.0485 11.3515C18.8235 11.1264 18.5183 11 18.2 11H6.2C5.88174 11 5.57652 11.1264 5.35147 11.3515Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenos);
export default __webpack_public_path__ + "static/media/menos.925bad73fa4979449dbd91d092507611.svg";
export { ForwardRef as ReactComponent };